// extracted by mini-css-extract-plugin
export default {"Checkbox":"CheckboxInput_Checkbox__LsqAx","StyledCheckbox":"CheckboxInput_StyledCheckbox__UBofR","Input":"CheckboxInput_Input__B-+oZ","Error":"CheckboxInput_Error__yXXRU"};